import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#D6CFC4] bg-[#EFECE5]" data-testid="site-footer">
      <div className="container-page py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="font-serif text-3xl text-[#1B3B36]">JetsetLess</div>
          <p className="mt-3 text-sm text-[#4A4742] max-w-sm">
            Premium editorial on travel, points & miles, and the cards that make the trip possible. Independent research, reader-first recommendations.
          </p>
          <div className="overline mt-6 text-[#4A4742]">Affiliate Disclosure</div>
          <p className="text-xs text-[#4A4742] mt-2 max-w-sm">JetsetLess earns commission from qualifying applications through affiliate links. Our editorial team decides what's covered, independent of advertising partners.</p>
        </div>
        <div>
          <div className="overline text-[#4A4742] mb-3">Sections</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/deals">Deals</Link></li>
            <li><Link to="/travel-hacks">Travel Hacks</Link></li>
            <li><Link to="/points-miles">Points & Miles</Link></li>
            <li><Link to="/destinations">Destinations</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#4A4742] mb-3">Brand</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/reviews">Reviews</Link></li>
            <li><Link to="/credit-cards">Credit Cards</Link></li>
            <li><Link to="/videos">Videos</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#4A4742] mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about">Editorial Independence</Link></li>
            <li><Link to="/about">Privacy</Link></li>
            <li><Link to="/about">Terms</Link></li>
            <li><Link to="/admin">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D6CFC4]">
        <div className="container-page py-5 text-xs text-[#4A4742] flex justify-between">
          <span>© {new Date().getFullYear()} JetsetLess Media. All rights reserved.</span>
          <span className="font-mono">jetsetless.com</span>
        </div>
      </div>
    </footer>
  );
}
